
export const GroupTypes = {
    SNUH: { str:"본원", enStr: "SNUH", class: "1" },
    SNUBH: { str:"분당", enStr: "SNUBH", class: "2" },
    BRMH: { str:"보라매", enStr: "BRMH", class: "3" },
    HEALTHCARE: { str:"강남", enStr: "HEALTH", class: "4" },
    CHILD: { str:"어린이병원", enStr: "CHILD", class: "5" },
    CANCER: { str:"암병원", enStr: "CANCER", class: "6" },
    undefined: { str: "", class: "6" },
}